module.exports = __webpack_public_path__ + "static/1983-3ae16d5f5cfbf91163557f209e10d75c.jpg";